//#region import
import React, { useEffect, useRef, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Divider, Grid, Radio, Typography } from '@mui/material';
import { TextBoxItem } from 'components/Input/TextBox';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { useLocation, useNavigate } from 'react-router';
import { DefaultArrayEmpty, Extension, FnAxios, FnDialog, I18n } from 'utilities/utilities';
import SwitchFormItem from 'components/Input/Switch';
import { BtnBack, BtnSave } from 'components/Button/ButtonAll';
import { SelectItem } from 'components/Input/Select/SelectItem';
import UploadFile from 'components/Input/UploadFile';
import { MultipleSelectItem } from 'components/Input/Select/MultipleSelectItem';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { CheckBoxListItem } from 'components/Input/Checkbox/CheckBoxListItem';
import { ICheckboxItem } from 'components/Input/Checkbox/CheckboxProps';
import moment from 'moment';
import { AutoCompleteItem } from 'components/Input/AutoComplete';
import { GetMenuPermission } from 'utilities/SystemFunction';
import { APIStatusCode } from 'enum/enum';
import { TextAreaItem } from 'components/Input/TextArea';
import { siLK } from '@mui/material/locale';
//#endregion

const UserForm = () => {
    const navigate = useNavigate();
    const onBack = () => navigate("/UserList");
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [loadingTable, setLoadingTable] = useState(false);
    const location = useLocation();
    const searchParams = location.search;
    const sID = new URLSearchParams(searchParams).get('sID');
    const [arrDataGroup, setarrDataGroup] = useState<any>([]);
    const [arrUserType, setarrUserType] = useState<any>([]);
    const [arrEmployeeType, setarrEmployeeType] = useState<any>([]);
    const [arrTimeAttendanceType, setarrTimeAttendanceType] = useState<any>([]);
    const [arrOrganization, setarrOrganization] = useState<any>([]);
    const [arrPosition, setarrPosition] = useState<any>([]);
    const [arrUserJob, setarrUserJob] = useState<any>([]);
    const [arrUserTitle, setarrUserTitle] = useState<any>([]);
    const [lstSelected, setlstSelected] = useState<any>([]);
    const [arrMuseum, setarrMuseum] = useState<any>([]);
    const [lstData, setLstData] = useState([]);
    const [arrImport, setarrImport] = useState([]);
    const onClearImportFile = useRef(null);
    const [nUserTypeID, setnUserTypeID] = useState(2);
    const [nTimeWork, setnTimeWork] = useState(0);
    const [arrPositionID, setarrPositionID] = useState([]);
    const [lstOrder, setlstOrder] = useState([]);
    const [isSchedule, setisSchedule] = useState(false);
    const [isAction, setisAction] = useState(false);
    const [isActive, setisActive] = useState(true);
    const [arrUserJobID, setarrUserjobID] = useState([1]);
    const [nEmployeeTypeID, setnEmployeeTypeID] = useState(0);
    const [isApproval, setApproval] = useState(false);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
    });

    const form = useForm({
        shouldFocusError: true,
        mode: "all"
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const onSubmit = (e, nMode) => {
        let lstChang = [];
        lstOrder.forEach((item) => {
            let objData = {
                nOrder: item.nOrder,
                nActingUserID: e[`nActingUserID${item.nOrder}`] ? e[`nActingUserID${item.nOrder}`].value : 0,
                nActingID: item.nActingID ? item.nActingID : 0
            };
            lstChang.push(objData)
        })

        let param = {
            sID: sID ? sID : "",
            nUserTypeID: form.getValues("nUserTypeID"),
            sFName: form.getValues("sFName"),
            sLName: form.getValues("sLName"),
            nOrgID: form.getValues("nOrgID"),
            nMuseumID: form.getValues("nMuseumID"),
            nEmployeeTypeID: form.getValues("nEmployeeTypeID"),
            lstPositionID: form.getValues("nPositionID") ? form.getValues("nPositionID") : [],
            nJobID: form.getValues("nJobID"),
            nWorkStartDate: form.getValues("dWorkStartDate") ? form.getValues("dWorkStartDate").valueOf() : 0,
            nWorkEndDate: form.getValues("dWorkEndDate") ? form.getValues("dWorkEndDate").valueOf() : 0,
            sEmail: form.getValues("sEmail"),
            sTelNo: form.getValues("sTelNo"),
            sMachineUserNumber: form.getValues("sMachineUserNumber"),
            nTimeAttendanceTypeID: form.getValues("nTimeAttendanceTypeID"),
            fFile: arrImport ?? [],
            lstGroupID: form.getValues("nGroupID") ? form.getValues("nGroupID") : [],
            lstPermission: dataRow.arrRows ? dataRow.arrRows : [],
            isActive: form.getValues("isActive"),
            nStartDate: form.getValues("dStartDate") ? form.getValues("dStartDate").valueOf() : 0,
            nEndDate: form.getValues("dEndDate") ? form.getValues("dEndDate").valueOf() : 0,
            lstActingUser: lstChang,
            isSchedule: form.getValues("nSchedule") ? e[`nSchedule`].length > 0 ? true : false : null,
            isApproval: form.getValues("nApproval") ? e[`nApproval`].length > 0 ? true : false : null,
            nTitleID: form.getValues("nTitleID"),
            sAddress: form.getValues("sAddress"),
            nMode: nMode,
            sLocation: location.pathname
        };
        DialogFn.Submit("คุณต้องการบันทึก ใช่หรือไม่", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(`User/SaveUser`, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Warning) {
                    DialogFn.SubmitWarning(result.sMessage, () => {
                        onSubmitMode(e, 2);
                        DialogFn.CloseSubmitWarning()
                    })
                } else {

                    DialogFn.Success(`บันทึกสำเร็จ`);
                    DialogFn.CloseSubmit()
                    navigate(`/UserList`);
                }
            }, (err) => {

                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };


    const onSubmitMode = (e, nMode) => {
        let lstChang = [];
        lstOrder.forEach((item) => {
            let objData = {
                nOrder: item.nOrder,
                nActingUserID: e[`nActingUserID${item.nOrder}`] ? e[`nActingUserID${item.nOrder}`].value : 0,
                nActingID: item.nActingID ? item.nActingID : 0
            };
            lstChang.push(objData)
        })
        let param = {
            sID: sID ? sID : "",
            nUserTypeID: form.getValues("nUserTypeID"),
            sFName: form.getValues("sFName"),
            sLName: form.getValues("sLName"),
            nOrgID: form.getValues("nOrgID"),
            nMuseumID: form.getValues("nMuseumID"),
            nEmployeeTypeID: form.getValues("nEmployeeTypeID"),
            lstPositionID: form.getValues("nPositionID") ? form.getValues("nPositionID") : [],
            nJobID: form.getValues("nJobID"),
            nWorkStartDate: form.getValues("dWorkStartDate") ? form.getValues("dWorkStartDate").valueOf() : 0,
            nWorkEndDate: form.getValues("dWorkEndDate") ? form.getValues("dWorkEndDate").valueOf() : 0,
            sEmail: form.getValues("sEmail"),
            sTelNo: form.getValues("sTelNo"),
            sMachineUserNumber: form.getValues("sMachineUserNumber"),
            nTimeAttendanceTypeID: form.getValues("nTimeAttendanceTypeID"),
            fFile: arrImport ?? [],
            lstGroupID: form.getValues("nGroupID"),
            lstPermission: dataRow.arrRows,
            isActive: form.getValues("isActive"),
            nStartDate: form.getValues("dStartDate") ? form.getValues("dStartDate").valueOf() : 0,
            nEndDate: form.getValues("dEndDate") ? form.getValues("dEndDate").valueOf() : 0,
            lstActingUser: lstChang,
            isSchedule: form.getValues("nSchedule") ? form.getValues("nSchedule") ? true : false : null,
            isApproval: form.getValues("nApproval") ? form.getValues("nApproval") ? true : false : null,
            nTitleID: form.getValues("nTitleID"),
            sAddress: form.getValues("sAddress"),
            nMode: nMode,
        };
        DialogFn.BlockUI();
        AxiosFn.Post(`User/SaveUser`, param, (result) => {
            DialogFn.UnBlockUI();
            DialogFn.Success(`บันทึกสำเร็จ`);
            DialogFn.CloseSubmit()
            navigate(`/UserList`);
        }, (err) => {
            DialogFn.UnBlockUI();
            if (!err.response) {
                DialogFn.Warning(err.sMessage);
            }
        });
    };

    const GetDataTable = (nGroupID) => {
        let lstChang = (lstSelected.arrRows ?? []);
        lstSelected.forEach((item) => {
            let objData = {
                isDisable: item.isDisable,
                isReadOnly: item.isReadOnly,
                isEnable: item.isEnable,
                sID: item.sID
            };
            lstChang.push(objData)
        })
        let param = {
            lstGroupID: nGroupID,
            lstSelected: lstChang
        };
        setLoadingTable(true);
        AxiosFn.Post(`User/GetMenuGroup`, param, (result) => {
            setLoadingTable(false);
            setLstData(result.lstPermission || [])
            setDataRow({
                ...dataRow,
                arrRows: result.lstPermission ?? [],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        }
        )
    };

    const GetGroupRoleEdit = () => {
        let param = {
            sID: sID ? sID : ""
        };
        setLoadingTable(true);
        AxiosFn.Post(`User/GetUserEdit`, param, (result) => {
            if (sID) {
                setnUserTypeID(result.nUserTypeID);
                setnEmployeeTypeID(result.nEmployeeTypeID);
                form.setValue("nUserTypeID", result.nUserTypeID);
                setarrPositionID(result.lstPositionID);
                if (result.lstActing.length > 0) {
                    setlstOrder(result.lstActing);
                }
                setisSchedule(result.isSchedule);

                setTimeout(() => {
                    if (result.lstActing.length > 0) {
                        (result.lstActing).forEach(f => {
                            f.nOrder = f.nOrder;
                            f.nActingID = f.nActingID;
                            form.setValue(`nActingUserID${f.nOrder}`, f.objEmployeeID);
                        })
                    }
                    form.setValue("dStartDate", result.nStartDate ? moment(result.nStartDate) : null);
                    form.setValue("dEndDate", result.nEndDate ? moment(result.nEndDate) : null);
                    form.setValue("dWorkEndDate", result.nWorkEndDate ? moment(result.nWorkEndDate) : null);
                    form.setValue("nMuseumID", result.nMuseumID);
                }, 1000);


                form.setValue("sFName", result.sFName);
                form.setValue("sLName", result.sLName);
                form.setValue("nOrgID", result.nOrgID);
                form.setValue("nEmployeeTypeID", result.nEmployeeTypeID);
                form.setValue("nPositionID", result.lstPositionID);
                form.setValue("nJobID", result.nJobID);
                form.setValue("dWorkStartDate", (result.nWorkStartDate > 0 ? moment(result.nWorkStartDate) : null));
                form.setValue("sEmail", result.sEmail);
                form.setValue("sAddress", result.sAddress);
                form.setValue("nTitleID", result.nTitleID);
                form.setValue("sTelNo", result.sTelNo);
                form.setValue("sMachineUserNumber", result.sMachineUserNumber);
                form.setValue("nTimeAttendanceTypeID", result.nTimeAttendanceTypeID);
                form.setValue("nGroupID", result.lstGroupID);
                form.setValue("isActive", result.isActive);

                form.setValue(`nApproval`, result.isApproval ? ["1"] : []);
                form.setValue(`nSchedule`, result.isSchedule ? ["1"] : []);

                setisActive(result.isActive);
                setarrImport([...result.fFile]);
                setnTimeWork(result.nTimeAttendanceTypeID || []);
                setisAction(result.isApproval);
                setApproval(result.isApproval);
                setLstData(result.lstPermission || [])
                setDataRow({
                    ...dataRow,
                    arrRows: result.lstPermission ?? [],
                    nDataLength: result.ObjTable?.nDataLength,
                    nPageIndex: result.ObjTable?.nPageIndex,
                });
                setLoadingTable(false);
                getPosition(result.nJobID, 2, result.lstPositionID);
                getGroupRole();
            }
        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        }
        );
    };


    const getFormInitial = () => {
        AxiosFn.Get(`User/GetFormInitial`, {}, (result) => {
            setarrUserType(result.lstUserType);
            setarrEmployeeType(result.lstEmployeeType);
            setarrTimeAttendanceType(result.lstTimeAttendanceType);
            setarrOrganization(result.lstOrganization);
            setarrUserJob(result.lstUserJob);
            setarrMuseum(result.lstDataMuseum);
            setarrUserTitle(result.lstUserTitle);
        })
    }


    const getPosition = (e, nMode, nPositionID) => {
        let param = {
            nOrgID: form.getValues("nOrgID"),
            nJobID: e
        };
        AxiosFn.Post(`User/GetPosition`, param, (result) => {
            setarrPosition(result.lstPosition);
        })
        if (form.getValues("nJobID") === 1 && form.getValues("nOrgID") === 1 && nMode === 1) {
            form.setValue("nPositionID", arrUserJobID);
            let nPositionID = form.getValues("nPositionID");
            setarrPositionID(nPositionID);
            setnUserTypeID(2);
        } else if (nMode === 1) {
            form.setValue("nPositionID", null);
            let nPositionID = form.getValues("nPositionID") ? form.getValues("nPositionID") : 0;
            setarrPositionID(nPositionID);
        }
    }
    const getGroupRole = () => {
        let param = {
            nUserTypeID: form.getValues("nUserTypeID"),
            lstGroupID: form.getValues("nGroupID") ? form.getValues("nGroupID") : [],
        };
        AxiosFn.Post(`User/GetTbGroupRole`, param, (result) => {
            setarrDataGroup(result.lstDataGroup);

        })
    }
    const setPosition = (e) => {
        setarrUserjobID([1])
        if (e === 1 && form.getValues("nOrgID") === 1) {
            form.setValue("nPositionID", arrUserJobID);

            let nPositionID = form.getValues("nPositionID");
            setarrPositionID(nPositionID);
            setnUserTypeID(2);
        } else {
            form.setValue("nPositionID", null);
            let nPositionID = form.getValues("nPositionID") ? form.getValues("nPositionID") : 0;
            setarrPositionID(nPositionID);
        }
    }

    const tempActing = {
        nOrder: 1,
        nActingUserID: 0,
        nActingID: 0
    };
    const AddComponent = (nRow = 1) => {
        if (nRow == 1) {
            let newData = { ...tempActing };
            let maxID = Math.max(...lstOrder.map((item) => item.nOrder));
            newData.nOrder = maxID < 1 ? 1 : maxID + 1;
            setlstOrder([...lstOrder, { ...newData }]);
        } else {
            let arrPoint = [] as any;
            for (let index = 0; index < nRow; index++) {
                let newData = { ...tempActing };
                let maxID = Math.max(...arrPoint.map((item) => item.nOrder));
                newData.nOrder = maxID < 1 ? 1 : maxID + 1;
                arrPoint.push(newData);
            }
            setlstOrder([...lstOrder, ...arrPoint]);
        }
    };
    const dataColumn: any = [
        {
            field: "sNo",
            headerName: "เลขที่",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 60,
            disableColumnMenu: true,
            renderCell: (item) => {
                return (
                    <>
                        {item.row.nLevel == 1 &&
                            <Typography sx={{ fontWeight: 500, fontSize: 15 }}>{item.row.sNo} </Typography>
                        }
                        {item.row.nLevel == 2 &&
                            <Typography sx={{ fontSize: 15 }}>{item.row.sNo} </Typography>
                        }
                    </>
                )
            }
        },
        {
            field: "sMenuName",
            headerName: "เมนู / ฟังก์ชัน",
            headerAlign: "center",
            align: "Left",
            sortable: false,
            flex: 1,
            width: 250,
            disableColumnMenu: true,
            renderCell: (item) => {
                return (
                    <>
                        {item.row.nLevel == 1 &&
                            <Typography sx={{ fontWeight: 500, fontSize: 15 }}>{item.row.sMenuName} </Typography>
                        }
                        {item.row.nLevel == 2 &&
                            <Typography sx={{ fontSize: 15 }}>{item.row.sMenuName} </Typography>
                        }
                    </>
                )
            }
        },

        {
            field: "isDisable",
            headerName: `ปิดการมองเห็น`,
            headerAlign: "center",
            align: "center",
            resizable: false,
            sortable: false,
            minWidth: 200,
            disableColumnMenu: true,
            renderCell: (item) => {
                if (item.row.isDisableMenu) {
                    return (
                        <Radio checked={item.value} disabled={item.row.isDisableChk || !isPermission} onChange={() => handleChangeRadio(item.row.sID, "isDisable")} />
                    )
                }
                else {
                    return <></>
                }

            }
        },
        {
            field: "isReadOnly",
            headerName: `เฉพาะการเข้าดู`,
            headerAlign: "center",
            align: "center",
            resizable: false,
            sortable: false,
            minWidth: 200,
            disableColumnMenu: true,
            renderCell: (item) => {
                if (item.row.isView) {
                    return (
                        <Radio checked={item.value} disabled={item.row.isReadOnlyChk || !isPermission} onChange={() => handleChangeRadio(item.row.sID, "isReadOnly")} />
                    )
                }
                else {
                    return <></>
                }
            }
        },
        {
            field: "isEnable",
            headerName: `เพิ่ม / แก้ไข / ลบ`,
            headerAlign: "center",
            align: "center",
            resizable: false,
            sortable: false,
            minWidth: 200,
            disableColumnMenu: true,
            renderCell: (item) => {
                if (item.row.isManage) {
                    return (
                        <Radio checked={item.value} disabled={item.row.isEnableChk || !isPermission} onChange={() => handleChangeRadio(item.row.sID, "isEnable",)} />
                    )
                }
                else {
                    return (
                        <Grid item xs={12} md={12} container spacing={1} justifyItems={'end'} justifyContent={'end'} style={{ margin: '5%', color: 'aliceblue' }}>.</Grid>
                    )
                }
            }
        }
    ];

    useEffect(() => {
        AddComponent(3);
        getFormInitial();
        if (sID != "") {
            form.setValue("isActive", true);
            GetGroupRoleEdit();
        }

    }, [])

    const handleChangeRadio = (sID, sField) => {
        let latdata = dataRow.arrRows;
        let oCheck = latdata.find((f) => f.sID === sID);
        if (oCheck) {
            oCheck.isDisable = sField === "isDisable";
            oCheck.isReadOnly = sField === "isReadOnly";
            oCheck.isEnable = sField === "isEnable";
            oCheck.isChang = true
        }

        let lstRow = lstSelected.filter(f => f.sID == sID)
        if (lstRow != null && lstRow.length > 0) {
            let Check = (lstRow[0].arrRows ?? []).find((f) => f.sID === sID);
            if (Check) {
                Check.isDisable = sField === "isDisable";
                Check.isReadOnly = sField === "isReadOnly";
                Check.isEnable = sField === "isEnable";

            }
        }
        else {
            let Check = [] as any;
            Check.isDisable = sField === "isDisable";
            Check.isReadOnly = sField === "isReadOnly";
            Check.isEnable = sField === "isEnable";
            Check.sID = sID
            setlstSelected([...lstSelected, Check]);
        }
        setDataRow({
            ...dataRow,
            arrRows: latdata ?? [],
            nDataLength: latdata.length,
        });
    };
    const DefaultDataOption = () => {

        let data: ICheckboxItem[] = [
            { label: "กำหนดการรักษาแทน", value: "1" }
        ];
        return data;
    }
    const setEndDate = (e) => {
        if (e.length > 0) {
            form.setValue("dEndDate", null);
            setApproval(true);
        }
    }

    const DefaultDataOpt = () => {
        let data: ICheckboxItem[] = [
            { label: "มอบอำนาจจนกว่าจะมีการเปลี่ยนแปลง", value: "1" }
        ];
        return data;

    }
    return (
        <>
            <FormProvider {...form}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <SelectItem
                            id="nUserTypeID"
                            name={"nUserTypeID"}
                            label={"ประเภทผู้มีสิทธิ์ใช้งานระบบ"}
                            placeholder={"ประเภทผู้มีสิทธิ์ใช้งานระบบ"}
                            options={arrUserType}
                            required={true}
                            disabled={!isPermission}
                            onChange={(e) => {
                                setnUserTypeID(e ? e.value : null)
                                getGroupRole();
                                setisSchedule(false)
                                setisAction(false)
                                form.setValue(`nSchedule`, []);
                                form.setValue(`nApproval`, []);
                                lstOrder.forEach(f => {
                                    f.nOrder = f.nOrder;
                                    f.nActingID = f.nActingID;
                                    form.setValue(`nActingUserID${f.nOrder}`, null);
                                })
                            }}
                        />
                    </Grid>
                    {nUserTypeID === 1 ?
                        <Grid item container xs={12} md={8}>
                            <SelectItem
                                id="nMuseumID"
                                name={"nMuseumID"}
                                label={"พิพิธภัณฑ์ (สังกัด)"}
                                placeholder={"พิพิธภัณฑ์ (สังกัด)"}
                                options={arrMuseum}
                                required={nUserTypeID === 1}
                                disabled={!isPermission}
                            />
                        </Grid>
                        : <Grid item xs={12} md={8}></Grid>}
                    <Grid item xs={12} md={2}>
                        <SelectItem
                            id="nTitleID"
                            name={"nTitleID"}
                            label={"คำนำหน้า"}
                            placeholder={"คำนำหน้า"}
                            options={arrUserTitle}
                            required={true}
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <TextBoxItem
                            name="sFName"
                            label='ชื่อ'
                            maxLength={100}
                            id={"sFName"}
                            required={true}
                            type={'text'}
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <TextBoxItem
                            name="sLName"
                            label='นามสกุล'
                            maxLength={100}
                            id={"sLName"}
                            required={true}
                            type={'text'}
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item container xs={12} md={12} spacing={2}>
                        {nUserTypeID === 2 ?
                            <Grid item container xs={12} md={12} spacing={2}>
                                <Grid item container xs={12} md={6}>

                                    <SelectItem
                                        id="nOrgID"
                                        name={"nOrgID"}
                                        label={"หน่วยงานสังกัด"}
                                        placeholder={"หน่วยงานสังกัด"}
                                        options={arrOrganization}
                                        required={true}
                                        disabled={!isPermission}
                                        onChange={(e) => {
                                            getPosition(e ? e.value : null, 1, 0)
                                        }}

                                    />
                                </Grid>
                                <Grid item container xs={12} md={6}>
                                    <SelectItem
                                        id="nEmployeeTypeID"
                                        name={"nEmployeeTypeID"}
                                        label={"ประเภทพนักงาน"}
                                        placeholder={"ประเภทพนักงาน"}
                                        options={arrEmployeeType}
                                        required={false}
                                        disabled={!isPermission}
                                        onChange={(e) => {
                                            setnEmployeeTypeID(e ? e.value : null)
                                        }}

                                    />
                                </Grid>
                                <Grid item container xs={12} md={6}>
                                    <SelectItem
                                        id="nJobID"
                                        name={"nJobID"}
                                        label={"ตำแหน่งทางวิชาการ"}
                                        placeholder={"ตำแหน่งทางวิชาการ*"}
                                        options={arrUserJob}
                                        required={true}
                                        disabled={!isPermission}
                                        onChange={(e) => {
                                            setPosition(e ? e.value : null)
                                            getPosition(e ? e.value : null, 1, 0)
                                        }}
                                    />
                                </Grid>
                                <Grid item container xs={12} md={6}>
                                    <MultipleSelectItem
                                        id={'nPositionID'}
                                        name={'nPositionID'}
                                        label={"ตำแหน่งบริหาร"}
                                        placeholder={'ตำแหน่งบริหาร'}
                                        IsClearable={true}
                                        options={arrPosition || []}
                                        required={false}
                                        disabled={!isPermission}
                                        onChange={(e) => {
                                            setarrPositionID(e ? e : null)
                                            setisSchedule(false)
                                            setisAction(false)
                                            form.setValue(`nSchedule`, []);
                                            form.setValue(`nApproval`, []);
                                            lstOrder.forEach(f => {
                                                f.nOrder = f.nOrder;
                                                f.nActingID = f.nActingID;
                                                form.setValue(`nActingUserID${f.nOrder}`, null);
                                            })
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            : <Grid></Grid>
                        }
                        {nUserTypeID === 2 &&
                            <Grid item container xs={12} md={6}>
                                <DatePickerItem
                                    name={"dWorkStartDate"}
                                    id={"dWorkStartDate"}
                                    label={"วันที่เริ่มเข้าทำงาน"}
                                    fullWidth
                                    disabled={!isPermission}
                                />
                            </Grid>
                        }
                        <Grid item container xs={12} md={6}>
                            <TextBoxItem
                                required={true}
                                label={`${I18n.SetText("email")}`}
                                id={'sEmail'}
                                name={'sEmail'}
                                maxLength={100}
                                type={'email'}
                                IsShowMessageError={true}
                                disabled={!isPermission}
                            />
                        </Grid>


                        <Grid item container xs={12} md={nUserTypeID === 2 ? 12 : 6}>
                            <TextBoxItem
                                name="sTelNo"
                                label='เบอร์โทรศัพท์'
                                maxLength={20}
                                id={"sTelNo"}
                                required={false}
                                type={'text'}
                                isTelNo={true}
                                disabled={!isPermission}
                                IsShowMessageError={true}
                                pattern={'en-number'}
                            />
                        </Grid>
                    </Grid>
                    {nUserTypeID === 2 &&
                        <Grid item xs={12} md={12}>
                            <TextAreaItem
                                placeholder=""
                                label='ที่อยู่'
                                name="sAddress"
                                maxLength={250}
                                id={"sAddress"}
                                required={nEmployeeTypeID === 102 ? true : false}
                            />
                        </Grid>
                    }
                    {nUserTypeID === 2 ?
                        <Grid item container xs={12} md={12} spacing={2}>
                            <Grid item xs={12} md={12}>
                                <Typography>
                                    กำหนดช่วงเวลา การเข้า-ออกงาน
                                </Typography>
                                <Divider />
                            </Grid>
                            <Grid item container xs={12} md={5.5}>
                                <SelectItem
                                    id="nTimeAttendanceTypeID"
                                    name={"nTimeAttendanceTypeID"}
                                    label={""}
                                    placeholder={"เลือกช่วงเวลา"}
                                    options={arrTimeAttendanceType}
                                    required={false}
                                    onChange={(e) => setnTimeWork(e ? e.value : null)}
                                    disabled={!isPermission}
                                />
                            </Grid>
                            {nTimeWork > 0 &&
                                <Grid item container xs={12} md={4}>
                                    <TextBoxItem
                                        name="sMachineUserNumber"
                                        label='เลขที่ผู้ใช้งานจากเครื่องแสกนนิ้ว/บัตร'
                                        maxLength={9}
                                        id={"sMachineUserNumber"}
                                        required={nTimeWork > 0 ? true : false}
                                        type={'text'}
                                        disabled={!isPermission}
                                    />
                                </Grid>
                            }
                        </Grid>
                        : <Grid></Grid>
                    }
                    <Grid item xs={12} md={12}>
                        <Typography>
                            รูปพนักงาน
                        </Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <UploadFile
                            id="sGalleryFile"
                            name={"sGalleryFile"}
                            label={""}
                            required={false}
                            arrFile={arrImport}
                            setarrFile={setarrImport}
                            sFolderTemp="UserProfileImage"
                            IsFolder={false}
                            IsMultiple={true}
                            Extension={[...Extension.Image]}
                            nLimitFile={10}
                            sLimitFile={"MB"}
                            onClearFile={onClearImportFile}
                            sPositionText="right"
                            IsCrop={true}
                            cropRatio={16 / 9}
                            cropMovable={true}
                            cropResize={true}
                            cropShape='retangle'
                            modeDisplay='gallery'
                            disabled={!isPermission}
                        />
                    </Grid>
                    {(arrPositionID.length > 0 && nUserTypeID === 2) ?
                        <Grid item container xs={12} md={12} spacing={2} >
                            <Grid item xs={12} md={12} sx={{ mt: 1 }}>
                                <CheckBoxListItem required={false} label={``} id={'Schedule'} name={'nSchedule'}
                                    onChange={(e) => {
                                        setisSchedule(e.length > 0 ? true : false);
                                        form.setValue(`nApproval`, []);
                                        lstOrder.forEach(f => {
                                            f.nOrder = f.nOrder;
                                            f.nActingID = f.nActingID;
                                            form.setValue(`nActingUserID${f.nOrder}`, null);
                                        })
                                    }}
                                    disabled={!isPermission}
                                    options={DefaultDataOption()}
                                ></CheckBoxListItem>
                                <Divider />
                            </Grid>
                        </Grid>
                        :
                        <Grid></Grid>
                    }
                    {(isSchedule && nUserTypeID === 2) &&
                        <Grid item container xs={12} md={12} spacing={2} >
                            <Grid item container xs={12} md={3}>
                                <DatePickerItem
                                    name={"dStartDate"}
                                    id={"dStartDate"}
                                    label={"ผู้แทนตั้งแต่วันที่"}
                                    fullWidth
                                    disabled={!isPermission}
                                    required={isSchedule && nUserTypeID === 2}
                                    IsDisablePortal={true}
                                />
                            </Grid>
                            <Grid item container xs={12} md={3}>
                                <DatePickerItem
                                    name={"dEndDate"}
                                    id={"dEndDate"}
                                    label={"ถึงวันที่"}
                                    fullWidth
                                    disabled={isAction || !isPermission}
                                    minDate={form.watch("dStartDate")}
                                    required={isSchedule && nUserTypeID === 2 && !isApproval}
                                    onChange={() => setApproval(false)}
                                    IsDisablePortal={true}
                                />
                            </Grid>
                            <Grid item container xs={12} md={6}>
                                <CheckBoxListItem
                                    label={``}
                                    id={'nApproval'}
                                    name={'nApproval'}
                                    onChange={(e) => {
                                        setisAction(e.length > 0 ? true : false);
                                        setEndDate(e);
                                    }}
                                    disabled={!isPermission}
                                    required={isSchedule && nUserTypeID === 2 && isApproval}
                                    options={DefaultDataOpt()}></CheckBoxListItem>
                            </Grid>

                            <Grid
                                item container xs={12} md={6} spacing={2}
                                direction="column"

                            >
                                {lstOrder.map((item, index) => {
                                    return (
                                        <Grid item xs={12} md={3} key={'GridUserID' + item.nOrder}  >
                                            <AutoCompleteItem
                                                id={'nActingUserID' + item.nOrder}
                                                name={'nActingUserID' + item.nOrder}
                                                sUrlAPI={`User/GetSearchEmployee`}
                                                label={`ผู้แทนลำดับที่${item.nOrder}`}
                                                placeholder={`ผู้แทนลำดับที่${item.nOrder}`}
                                                required={isSchedule && nUserTypeID === 2 && item.nOrder === 1}
                                                disabled={!isPermission}
                                                sParam={sID}
                                            />
                                        </Grid>
                                    )
                                })
                                }
                            </Grid>
                            <Grid
                                item container xs={12} md={6}
                            >
                            </Grid>
                        </Grid>
                    }
                    <Grid item xs={12} md={12}>
                        <Typography>
                            กลุ่มผู้ใช้งานระบบ
                            <span style={{ color: "red" }}> * </span>
                        </Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} md={5.5}>
                        <MultipleSelectItem
                            id={'nGroupID'}
                            name={'nGroupID'}
                            label={"กลุ่มผู้ใช้งาน"}
                            placeholder={'เลือกกลุ่มผู้ใช้งาน'}
                            options={arrDataGroup || []}
                            required={true}
                            disabled={!isPermission}
                            limitTag={1}
                            onChange={(v) => {
                                GetDataTable(v);
                            }}
                        />
                    </Grid>
                    {lstData.length > 0 &&
                        <Grid item xs={12} md={12}>
                            <Typography>
                                กำหนดสิทธิ์การใช้งาน
                                <span style={{ color: "red" }}> * </span>
                            </Typography>
                            <Divider />
                        </Grid>
                    }
                    {lstData.length > 0 &&
                        <Grid item xs={12} md={12}>
                            <DataGrid
                                isLoading={loadingTable}
                                columns={dataColumn}
                                rows={dataRow}
                                isHiddenToolHead={true}
                                isHiddenFooter={true}
                                isShowCheckBox={false}
                            />
                        </Grid>
                    }
                    <Grid item xs={12} md={12}>
                        <Typography>
                            สถานะ
                            <span style={{ color: "red" }}> * </span>
                        </Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <SwitchFormItem
                            name={"isActive"}
                            checkText='ใช้งาน'
                            uncheckText='ไม่ใช้งาน'
                            width={130}
                            id={"isActive"}
                            disabled={!isPermission}
                            onChange={(e) => {
                                setisActive(e ? true : false);
                            }}
                        />
                    </Grid>
                    {!isActive &&
                        <Grid item container xs={12} md={3}>
                            <DatePickerItem
                                name={"dWorkEndDate"}
                                id={"dWorkEndDate"}
                                label={"วันที่สิ้นสุดกาารทำงาน"}
                                fullWidth
                                disabled={!isPermission}
                                IsDisablePortal={true}
                            />
                        </Grid>
                    }
                </Grid>

                <Grid container justifyContent="flex-start" sx={{ mt: 5 }}>
                    <Grid item xs={6} md={6}>
                        <BtnBack id={"btnBack"} onClick={() => onBack()} />
                    </Grid>

                    <Grid container item xs={6} md={6} justifyContent="flex-end">
                        <BtnSave
                            IsDisabled={!isPermission}
                            id={"btnSave"}
                            onClick={form.handleSubmit(
                                (e) => onSubmit(e, 1),
                                (err) => console.log("err", err)
                            )}
                        />
                    </Grid>
                </Grid>

            </FormProvider>
        </>
    )
}


export default UserForm;

export const enum EnumPermission {
    Disable = 0,
    ReadOnly = 1,
    Enable = 2,
}

export const enum EnumPosition {
    DirectorProtection = 1,
    DivisionDirector = 3,

}

export interface ActingUser {
    nActingUserID: number
    nOrder: number

}